import { useTranslations } from '@lang';

interface RoomCapacityProps {
  maxAdults?: number | null;
  maxChildren?: number | null;
  maxOccupancy?: number | null;
}

export default function useRoomCapacityText({
  maxAdults,
  maxChildren,
  maxOccupancy,
}: RoomCapacityProps) {
  const { t } = useTranslations();
  if (maxOccupancy || maxAdults) {
    return t('room.roomSleeps', {
      maxOccupancy: maxOccupancy ?? (maxAdults ?? 0) + (maxChildren ?? 0),
    });
  }

  return '';
}
